import gql from 'graphql-tag';

export const GET_VENUE_HEADER_INFO = gql`
  query getVenueHeaderInfo($venueUuid: String!) {
    searchMerchantVenues(
      params: {
        offerNetworkVenueId: $venueUuid
        pagingInput: { offset: 0, limit: 1 }
      }
    ) {
      result {
        venueName
        postalCode
        locationCreationDate
        address1
        city
        state
        imageUrl
        latitude
        longitude
        locationId
      }
    }
  }
`;

export default GET_VENUE_HEADER_INFO;
